/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * SquadLocker Accounts Storefront Public API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, QueryClient, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import type {
  ApiResponse,
  DIYQuickStartCommand,
  DIYSignupCommand,
  QuickStartSignupResponseDtoApiResponse,
  SignupResponseDtoApiResponse,
} from '../accounts.schemas.ts';

import { fetcher } from '../../../http.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getPostStorefrontPublicApiV1SignupUrl = () => {
  return `/storefront-public/api/v1/signup`;
};

export const postStorefrontPublicApiV1Signup = async (
  dIYSignupCommand?: DIYSignupCommand,
  options?: RequestInit,
): Promise<SignupResponseDtoApiResponse> => {
  return fetcher<SignupResponseDtoApiResponse>(getPostStorefrontPublicApiV1SignupUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dIYSignupCommand),
  });
};

export const getPostStorefrontPublicApiV1SignupMutationOptions = <TError = ApiResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postStorefrontPublicApiV1Signup>>, TError, { data?: DIYSignupCommand }, TContext>;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof postStorefrontPublicApiV1Signup>>, TError, { data?: DIYSignupCommand }, TContext> => {
  const mutationKey = ['postStorefrontPublicApiV1Signup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStorefrontPublicApiV1Signup>>, { data?: DIYSignupCommand }> = (props) => {
    const { data } = props ?? {};

    return postStorefrontPublicApiV1Signup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostStorefrontPublicApiV1SignupMutationResult = NonNullable<Awaited<ReturnType<typeof postStorefrontPublicApiV1Signup>>>;
export type PostStorefrontPublicApiV1SignupMutationBody = DIYSignupCommand | undefined;
export type PostStorefrontPublicApiV1SignupMutationError = ApiResponse;

export const usePostStorefrontPublicApiV1Signup = <TError = ApiResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof postStorefrontPublicApiV1Signup>>, TError, { data?: DIYSignupCommand }, TContext>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof postStorefrontPublicApiV1Signup>>, TError, { data?: DIYSignupCommand }, TContext> => {
  return useMutation(getPostStorefrontPublicApiV1SignupMutationOptions(options), queryClient);
};
export const getPostStorefrontPublicApiV1SignupQuickStartUrl = () => {
  return `/storefront-public/api/v1/signup/quick-start`;
};

export const postStorefrontPublicApiV1SignupQuickStart = async (
  dIYQuickStartCommand?: DIYQuickStartCommand,
  options?: RequestInit,
): Promise<QuickStartSignupResponseDtoApiResponse> => {
  return fetcher<QuickStartSignupResponseDtoApiResponse>(getPostStorefrontPublicApiV1SignupQuickStartUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dIYQuickStartCommand),
  });
};

export const getPostStorefrontPublicApiV1SignupQuickStartMutationOptions = <TError = ApiResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStorefrontPublicApiV1SignupQuickStart>>,
    TError,
    { data?: DIYQuickStartCommand },
    TContext
  >;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof postStorefrontPublicApiV1SignupQuickStart>>, TError, { data?: DIYQuickStartCommand }, TContext> => {
  const mutationKey = ['postStorefrontPublicApiV1SignupQuickStart'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStorefrontPublicApiV1SignupQuickStart>>, { data?: DIYQuickStartCommand }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return postStorefrontPublicApiV1SignupQuickStart(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostStorefrontPublicApiV1SignupQuickStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof postStorefrontPublicApiV1SignupQuickStart>>
>;
export type PostStorefrontPublicApiV1SignupQuickStartMutationBody = DIYQuickStartCommand | undefined;
export type PostStorefrontPublicApiV1SignupQuickStartMutationError = ApiResponse;

export const usePostStorefrontPublicApiV1SignupQuickStart = <TError = ApiResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStorefrontPublicApiV1SignupQuickStart>>,
      TError,
      { data?: DIYQuickStartCommand },
      TContext
    >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof postStorefrontPublicApiV1SignupQuickStart>>, TError, { data?: DIYQuickStartCommand }, TContext> => {
  return useMutation(getPostStorefrontPublicApiV1SignupQuickStartMutationOptions(options), queryClient);
};
